class VoyadoController extends AbstractIntegrationController
	@register()
	@inject 'configuration', 'configurationOptions'

	integrationId: 'voyado'

	save: ->
		super(@configuration).then =>
			@configuration.is_active = true

	afterDisconnect: ->
		@configuration = {
			active: false
		}
